import React from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';


// Components
import CircularProgress from "components/master/CircularProgress";


// Scss
import "./ImpactsTracking.scss";

// Icons & Images
import ThumbsUp from "assets/icons/thumb-up.svg";
import ImpactSummary from "assets/icons/impact-summary.svg";
// import Rag from "assets/icons/rag.svg";
// import UserIcon from "assets/icons/user-icon.svg";
// import CalendarIcon from "assets/icons/calendar-icon.svg";
import BaselineIcon from "assets/icons/baseline-icon.svg";
import TargetValueIcon from "assets/icons/target-value-icon.svg";
import ActualValueIcon from "assets/icons/actual-value-icon.svg";
import MeasurementDatesIcon from "assets/icons/measurement-dates.svg";
import EmployeeRetention from "assets/icons/employee-retention.svg";
import EmployeeSatisfication from "assets/icons/employee-satisfication.svg";
import EmployeeComplaints from "assets/icons/employee-complaints.svg";
import PriorityIcon from "assets/icons/priority-icon.svg";
import Change from "assets/icons/change.svg";
// import ChangeGreen from "assets/icons/change-green.svg";
// import ChangeYellow from "assets/icons/change-yellow.svg";
// import ChangeArrowDown from "assets/icons/change-arrowdown.svg";
// import ChangeArrowUp from "assets/icons/change-arrowup.svg";
// import ChangeArrowStraight from "assets/icons/change-arrowstraight.svg";
import ChangeArrowGreen from "assets/icons/change-arrowgreen.svg";
import ChangeArrowAmber from "assets/icons/change-arrowamber.svg";
import ChangeArrowRed from "assets/icons/change-arrowred.svg";


import ActionsRequiredIcon from "assets/icons/actions-required.svg";
import Calenders from "assets/icons/calenders.svg";
import ProjectStatus from "assets/icons/project-status.svg";
import GreenBg from "assets/images/circular-green-bg.svg";
import BlueBg from "assets/images/circular-blue-bg.svg";
import YellowBg from "assets/images/circular-yellow-bg.svg";


function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ImpactsTrackingDash() {
  let query = useQuery();
  function generateUUID() {
    return uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
  }
  // let navgiate = useNavigate();
  // function redirectPage(to) {
  //   navgiate(to);
  // }

  return (
    <>
      <section className="ref-benefit">
        
        <div className="tile benefit">
          <div className="ref-mark">
            <div className="circular-icon-container">
              <img src={ThumbsUp} alt="#" />
            </div>
            <div className="title">Strategic Objective</div>
          </div>
          <div className="ref-alpha so">
            <div className="value">
              <p>Improve morale and individual performance of MoD staff</p>
            </div>
          </div>
        </div>
      </section>   
      <section>
        <div className="section-header">
          <div className="lines gap-right">
              <hr/>
            </div>
          <div className="header-info">
            <div className="icon-container">
              <img src={ImpactSummary} alt="#"/>
            </div>
            <div className="info-container">
              <span>MEASUREMENT OF IMPACT</span>
              <span>
              {
               (query.get('so') === '1') && <>(Employee Retention)</> 
            }
            {
               (query.get('so') === '2') && <>(TOM Process Activation)</> 
            }
            {
               (query.get('so') === '3') && <>(Operational Rediness)</>
            }
            {
               (query.get('so') === '4') && <>(Interoperability)</>
            }
            {
               (query.get('so') === '5') && <>(Reduce Financial Risk)</>
            }
              </span>
            </div>
          </div>
          <div className="lines gap-left">
              <hr/>
            </div>
        </div>
      </section>
      <section className="charts-and-data">
      <div className="employee-status mr">
          <div className="icon-holder green">
            <img src={EmployeeRetention} alt="#" />
          </div>
          <span>
            {
               (query.get('so') === '1') && <>Employee <br/>Retention</> 
            }
            {
               (query.get('so') === '2') && <>TOM Process <br/> Activation</> 
            }
            {
               (query.get('so') === '3') && <>Operational <br/> Rediness</>
            }
            {
               (query.get('so') === '4') && <>Interoperability</>
            }
            {
               (query.get('so') === '5') && <>Reduce Financial <br/> Risk</>
            }
            
          </span>
          <div className="status-holder">
            <span className="status-label">Status</span>
            <div className="status green"></div>
          </div>
        </div>
        <div className="chart-container mr baseline-value">
          <img src={BaselineIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: GreenBg,
              value: '75',
            }}
          />
          <span>Baseline Value</span>
        </div>
        <div className="chart-container mr target-value">
          <img src={TargetValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: BlueBg,
              value: '75',
            }}
          />
          <span>Target Value</span>
        </div>
        <div className="chart-container mr actual-value">
          <img src={ActualValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: YellowBg,
              value: '75',
            }}
          />
          <span>Actual Value</span>
        </div>
        <div className="data-container mr">
          <div className="top-float">
            <span>
              <img src={MeasurementDatesIcon} alt="#" />
              Measurement Dates
            </span>
            <div className="dates">
              <span>Baseline</span>
              <div className="seperator"><hr/></div>
              <span>23-02-2022</span>
            </div>
            <div className="dates">
              <span>Previous</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
            <div className="dates">
              <span>Current</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
          </div>
          <div className="done-by">
            <span>Measurement To Be Done By</span>
            <span>Mahmoud Al Hamid</span>
          </div>
        </div>
      </section>
      <section className="meta-data">
        <div className="date-container">
          <div className="top-float sep">
            <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>START DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
          <div className="bottom-float sh-none" >
          <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>END DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
        </div>
        <div className="basic-tile mr">
          <img src={PriorityIcon} alt="#" />
          <span>Priority</span>
          <span className="pnumber">4<span className="outof">/ 5</span></span>
          <div className="color-meanings">
            <div className="color-codes">
              <div className="circle verylow"></div>
              <span className="verylow">VERY LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle low"></div>
              <span className="low">LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle medium"></div>
              <span className="medium">MEDIUM</span>
            </div>
            <div className="color-codes">
              <div className="circle high"></div>
              <span className="high">HIGH</span>
            </div>
            <div className="color-codes">
              <div className="circle veryhigh"></div>
              <span className="veryhigh">VERY HIGH</span>
            </div>
          </div>
        </div>
        <div className="basic-tile mr">
        <div className="icon-holder green">
            <img src={Change} alt="#" />
          </div>
          <span>Change</span>
          <div className="change-percentage">
            <img src={ChangeArrowGreen} alt="#" className=""/>
            <span className="green-text">0%</span>
          </div>
          <div className="p-bar green-blur">
            <div className="p-bar-percentage green" style={{width: 0}}></div>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>REASON FOR CHANGE</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>ACTIONS REQUIRED TO REALISE THE BENEFIT</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
      </section>
      <section>
        <div className="section-header">
          <div className="lines gap-right">
              <hr/>
            </div>
          <div className="header-info">
            <div className="icon-container">
              <img src={ImpactSummary} alt="#"/>
            </div>
            <div className="info-container">
              <span>MEASUREMENT OF IMPACT</span>
              <span>
              {
               (query.get('so') === '1') && <>(Employee Satisfaction)</> 
              }
              {
                (query.get('so') === '2') && <>(Fullfill Forces Requirements)</> 
              }
              {
                (query.get('so') === '3') && <>(Apply New Doctrine)</>
              }
              {
                (query.get('so') === '4') && <>(Increase Survivability)</>
              }
              {
                (query.get('so') === '5') && <>(Increase WS Lifespan)</>
              }
              </span>
            </div>
          </div>
          <div className="lines gap-left">
              <hr/>
            </div>
        </div>
      </section>
      <section className="charts-and-data">
      <div className="employee-status mr">
          <div className="icon-holder amber">
            <img src={EmployeeSatisfication} alt="#" />
          </div>
          <span>
            {
               (query.get('so') === '1') && <>Employee <br/> Satisfaction</> 
              }
              {
                (query.get('so') === '2') && <>Fullfill Forces <br/> Requirements</> 
              }
              {
                (query.get('so') === '3') && <>Apply New <br/> Doctrine</>
              }
              {
                (query.get('so') === '4') && <>Increase <br/>Survivability</>
              }
              {
                (query.get('so') === '5') && <>Increase WS <br/>Lifespan</>
              }
            
          </span>
          <div className="status-holder">
            <span className="status-label">Status</span>
            <div className="status amber"></div>
          </div>
        </div>
        <div className="chart-container mr baseline-value">
          <img src={BaselineIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: GreenBg,
              value: '90',
            }}
          />
          <span>Baseline Value</span>
        </div>
        <div className="chart-container mr target-value">
          <img src={TargetValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: BlueBg,
              value: '90',
            }}
          />
          <span>Target Value</span>
        </div>
        <div className="chart-container mr actual-value">
          <img src={ActualValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: YellowBg,
              value: '80',
            }}
          />
          <span>Actual Value</span>
        </div>
        <div className="data-container mr">
          <div className="top-float">
            <span>
              <img src={MeasurementDatesIcon} alt="#" />
              Measurement Dates
            </span>
            <div className="dates">
              <span>Baseline</span>
              <div className="seperator"><hr/></div>
              <span>23-02-2022</span>
            </div>
            <div className="dates">
              <span>Previous</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
            <div className="dates">
              <span>Current</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
          </div>
          <div className="done-by">
            <span>Measurement To Be Done By</span>
            <span>Mahmoud Al Hamid</span>
          </div>
        </div>
      </section>
      <section className="meta-data">
        <div className="date-container">
          <div className="top-float sep">
            <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>START DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
          <div className="bottom-float sh-none" >
          <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>END DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
        </div>
        <div className="basic-tile mr">
          <img src={PriorityIcon} alt="#" />
          <span>Priority</span>
          <span className="pnumber">4<span className="outof">/ 5</span></span>
          <div className="color-meanings">
            <div className="color-codes">
              <div className="circle verylow"></div>
              <span className="verylow">VERY LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle low"></div>
              <span className="low">LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle medium"></div>
              <span className="medium">MEDIUM</span>
            </div>
            <div className="color-codes">
              <div className="circle high"></div>
              <span className="high">HIGH</span>
            </div>
            <div className="color-codes">
              <div className="circle veryhigh"></div>
              <span className="veryhigh">VERY HIGH</span>
            </div>
          </div>
        </div>
        <div className="basic-tile mr">
          <div className="icon-holder amber">
            <img src={Change} alt="#" />
          </div>
          <span>Change</span>
          <div className="change-percentage">
            <img src={ChangeArrowAmber} alt="#" className="rotate-down"/>
            <span className="amber-text">10%</span>
          </div>
          <div className="p-bar amber-blur">
            <div className="p-bar-percentage amber" style={{ width: 10 }}></div>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>REASON FOR CHANGE</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>ACTIONS REQUIRED TO REALISE THE BENEFIT</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
      </section>
      <section>
        <div className="section-header">
          <div className="lines gap-right">
              <hr/>
            </div>
          <div className="header-info">
            <div className="icon-container">
              <img src={ImpactSummary} alt="#"/>
            </div>
            <div className="info-container">
              <span>MEASUREMENT OF IMPACT</span>
              <span>
              {
               (query.get('so') === '1') && <>(Employee Complaints)</> 
              }
              {
                (query.get('so') === '2') && <>(Data Driven Decisions)</> 
              }
              {
                (query.get('so') === '3') && <>(Unmet Requirements)</>
              }
              {
                (query.get('so') === '4') && <>(Employee New Systems)</>
              }
              {
                (query.get('so') === '5') && <>(Increase Local Markets)</>
              }
              </span>
            </div>
          </div>
          <div className="lines gap-left">
              <hr/>
            </div>
        </div>
      </section>
      <section className="charts-and-data">
      <div className="employee-status mr">
          <div className="icon-holder red">
            <img src={EmployeeComplaints} alt="#" />
          </div>
          <span>
          {
               (query.get('so') === '1') && <>Employee <br/>Complaints</> 
              }
              {
                (query.get('so') === '2') && <>Data Driven  <br/>Decisions</> 
              }
              {
                (query.get('so') === '3') && <>Unmet  <br/>Requirements</>
              }
              {
                (query.get('so') === '4') && <>Employee New <br/> Systems</>
              }
              {
                (query.get('so') === '5') && <>Increase Local <br/> Markets</>
              }
          </span>
          <div className="status-holder">
            <span className="status-label">Status</span>
            <div className="status red"></div>
          </div>
        </div>
        <div className="chart-container mr baseline-value">
          <img src={BaselineIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: GreenBg,
              value: '25',
            }}
          />
          <span>Baseline Value</span>
        </div>
        <div className="chart-container mr target-value">
          <img src={TargetValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: BlueBg,
              value: '25',
            }}
          />
          <span>Target Value</span>
        </div>
        <div className="chart-container mr actual-value">
          <img src={ActualValueIcon} alt="#" />
          <CircularProgress
            data={{
              pbId: `pb-${generateUUID()}`,
              vcId: `vc-${generateUUID()}`,
              img: YellowBg,
              value: '10',
            }}
          />
          <span>Actual Value</span>
        </div>
        <div className="data-container mr">
          <div className="top-float">
            <span>
              <img src={MeasurementDatesIcon} alt="#" />
              Measurement Dates
            </span>
            <div className="dates">
              <span>Baseline</span>
              <div className="seperator"><hr/></div>
              <span>23-02-2022</span>
            </div>
            <div className="dates">
              <span>Previous</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
            <div className="dates">
              <span>Current</span>
              <div className="seperator"><hr/></div>
              <span>12-02-2022</span>
            </div>
          </div>
          <div className="done-by">
            <span>Measurement To Be Done By</span>
            <span>Mahmoud Al Hamid</span>
          </div>
        </div>
      </section>
      <section className="meta-data">
        <div className="date-container">
          <div className="top-float sep">
            <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>START DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
          <div className="bottom-float sh-none" >
          <span>
              <img src={Calenders} alt="#" />
              <div>
                <span>END DATE</span>
                <span className="date">23-03-2022</span>
              </div>
            </span>
          </div>
        </div>
        <div className="basic-tile mr">
          <img src={PriorityIcon} alt="#" />
          <span>Priority</span>
          <span className="pnumber">4<span className="outof">/ 5</span></span>
          <div className="color-meanings">
            <div className="color-codes">
              <div className="circle verylow"></div>
              <span className="verylow">VERY LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle low"></div>
              <span className="low">LOW</span>
            </div>
            <div className="color-codes">
              <div className="circle medium"></div>
              <span className="medium">MEDIUM</span>
            </div>
            <div className="color-codes">
              <div className="circle high"></div>
              <span className="high">HIGH</span>
            </div>
            <div className="color-codes">
              <div className="circle veryhigh"></div>
              <span className="veryhigh">VERY HIGH</span>
            </div>
          </div>
        </div>
        <div className="basic-tile mr">
          <div className="icon-holder red">
            <img src={Change} alt="#" />
          </div>
          <span>Change</span>
          <div className="change-percentage">
            <img src={ChangeArrowRed} alt="#" className="rotate-up"/>
            <span className="red-text">15%</span>
          </div>
          <div className="p-bar red-blur">
            <div className="p-bar-percentage red" style={{ width: 15}}></div>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>REASON FOR CHANGE</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
        <div className="stretch-tile mr">
          <img src={ActionsRequiredIcon} alt="#" />
          <span>ACTIONS REQUIRED TO REALISE THE BENEFIT</span>
          <div className="typography">
            <p>.....</p>
          </div>
        </div>
      </section>
      {/* <section className="impact-summary">
        <div className="tile">
          <div className="impact-summary-head">
            <div className="lines gap-right">
              <hr/>
            </div>
              <span>
                <img src={ImpactSummary} alt="#" />
                Project Summary
              </span>
            <div className="lines gap-left">
              <hr/>
            </div>
          </div>
          <div className="summary-detail">
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={Rag} alt="#" />
                  Current RAG Status
                </span>
              </div>
              <div className="stick-end">
                <span className="tag"></span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={UserIcon} alt="#" />
                  Director Owner
                </span>
              </div>
              <div className="stick-end">
                <span>An Other</span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={CalendarIcon} alt="#" />
                  End date to be realized
                </span>
              </div>
              <div className="stick-end">
                <span>23-03-2022</span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={UserIcon} alt="#" />
                   Operational Owner
                </span>
              </div>
              <div className="stick-end">
                <span>An Other</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="project-status">
          <div className="section-inner-header">
            <img src={ProjectStatus} alt="#"/>
            <span className="head-title">PROJECT STATUS</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Project ID</th>
                <th>Project Name</th>
                <th>Implementing Agent</th>
                <th>Duration</th>
                <th>Start Date</th>
                <th>Finish Date</th>
                <th>CPI</th>
                <th>SPI</th>
                <th>% Completed</th>
                <th>Overall Status</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
              <td>
                  <a target="_blank" rel="noreferrer" href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78">Project 1</a>
                </td>
                <td>Pname</td>
                <td>Mohammed Reda</td>
                <td>10 Months</td>
                <td>23-03-2022</td>
                <td>15-07-2022</td>
                <td>10.5</td>
                <td>12.6</td>
                <td>50%</td>
                <td className="significant-delay">Significant Delay</td>
                <td>Remarks......</td>
              </tr>
              <tr>
              <td>
                  <a target="_blank" rel="noreferrer" href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78">Project 1</a>
                </td>
                <td>Pname</td>
                <td>Mohammed Reda</td>
                <td>10 Months</td>
                <td>23-03-2022</td>
                <td>15-07-2022</td>
                <td>10.5</td>
                <td>12.6</td>
                <td>50%</td>
                <td className="moderate-delay">Moderate Delay</td>
                <td>Remarks......</td>
              </tr>
              <tr>
              <td>
                  <a target="_blank" rel="noreferrer" href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78">Project 1</a>
                </td>
                <td>Pname</td>
                <td>Mohammed Reda</td>
                <td>10 Months</td>
                <td>23-03-2022</td>
                <td>15-07-2022</td>
                <td>10.5</td>
                <td>12.6</td>
                <td>50%</td>
                <td className="not-started">Not Started</td>
                <td>Remarks......</td>
              </tr>
              <tr>
              <td>
                  <a target="_blank" rel="noreferrer" href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78">Project 1</a>
                </td>
                <td>Pname</td>
                <td>Mohammed Reda</td>
                <td>10 Months</td>
                <td>23-03-2022</td>
                <td>15-07-2022</td>
                <td>10.5</td>
                <td>12.6</td>
                <td>50%</td>
                <td className="on-track">On Track</td>
                <td>Remarks......</td>
              </tr>
            </tbody>
          </table>
      </section>
    
    </>
  );
}

export default ImpactsTrackingDash;
